import {css} from 'styled-components';

// import {reset} from "./reset";

// import {font_gothic} from "./mixin";
// import {color_default} from "./mixin";
// import {color_main} from "./mixin";
import {transition_default} from "./mixin";
import {opacity_default} from "./mixin";
import {break_point_pc} from "./mixin";
import {break_point_sp} from "./mixin";

export const base = css`

//==============================
//		Web font
//==============================

.c-font_f--km {
	font-family: 'Kiwi Maru', serif;
}

//==============================
//		共通設定
//==============================
*{
	box-sizing: border-box;
}

.img{
	img{
			width: 100%;
			vertical-align: bottom;
		}
	}

.l-box{
	.l-box__txt{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
	.l-box__img{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
	.l-box__list{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
	.l-box__part{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
	.l-box__link{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
	.l-box__btn{
		&+.l-box__txt,&+.l-box__img,&+.l-box__list,&+.l-box__part,&+.l-box__link,&+.l-box__btn{
			margin-top: 20px;
		}
	}
}

//==============================
//
//==============================

.isDisplayBlock{
	display: block;
	opacity: 1;
}
.isDisplayNone{
	display: none;
	opacity: 0;
}
.isFadeInNormal{
	animation: fadeInAnimeNormal 2s ease forwards;
}
.isFadeIn{
	animation: fadeInAnime 1s ease forwards;
}
.isFadeOut{
	animation: fadeOutAnime 1s ease forwards;
}
@keyframes fadeInAnimeNormal {
	0%{
		opacity: 0;
		visibility: hidden;
	}
	100%{
		opacity: 1;
		visibility: visible;
	}
}
@keyframes fadeInAnime {
	0%{
		opacity: 0;
		visibility: hidden;
		transform: translateY(-50px);
	}
	100%{
		opacity: 1;
		visibility: visible;
		transform: translateY(0px);
	}
}
@keyframes fadeOutAnime {
	0%{
		opacity: 1;
		visibility: visible;
	}
	100%{
		opacity: 0;
		visibility: hidden;
	}
}

//==============================
//		PC
//==============================
@media ${break_point_pc}{
	.sp_only{
		display: none;
	}
	.pc_only{
		display: block;
	}

	.l-inner--1100{
		width: 1100px;
		margin-left: auto;
		margin-right: auto;
	}

	a{
		${transition_default}
		&:hover{
			${opacity_default}
		}
	}

}

//==============================
//		SP
//==============================
@media ${break_point_sp}{
	.sp_only{
		display: block;
	}
	.pc_only{
		display: none;
	}

	.l-inner--92{
		max-width: 92%;
		margin-left: auto;
		margin-right: auto;
	}
}


`;
